var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 7.235c-2.414 2.446-4.237 5.244-5.767 8.31A7.98 7.98 0 0 0 12 20a7.98 7.98 0 0 0 5.767-2.455c-1.53-3.067-3.353-5.864-5.767-8.31m-4.642-3.75A7.99 7.99 0 0 0 4 12c0 1.345.332 2.613.919 3.726c1.502-2.848 3.3-5.499 5.623-7.86a27 27 0 0 0-3.184-2.382Zm9.284 0a27 27 0 0 0-3.184 2.38c2.323 2.362 4.12 5.013 5.623 7.861A8 8 0 0 0 20 12a7.99 7.99 0 0 0-3.358-6.516ZM12 4c-.914 0-1.793.153-2.611.436q1.398.975 2.611 2.048a29 29 0 0 1 2.611-2.048A8 8 0 0 0 12 4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbox);
export default __webpack_public_path__ + "static/media/xbox.2b8e6322b2030ce808a854f85ec303b4.svg";
export { ForwardRef as ReactComponent };